import { getApiUrl } from './apiConfig';

/**
 * Service to fetch subject quiz scores for a specific student (for teacher view)
 */
export const getStudentSubjectScores = async (userId) => {
  try {
    const response = await fetch(getApiUrl(`student-subject-scores?user_id=${userId}`));
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching student subject scores:', error);
    return null;
  }
};
